module.exports = __webpack_public_path__ + "static/media/add-message.3c3d0861.svg";